<template>
    <div class="check_box">
        <p class="info"
           v-if="scenceCode != 2">
            <span class="line"></span>{{ info }}
        </p>
        <!-- <p class="i_title"><span class="line"></span>选择审批通道并提交</p> -->
        <!-- <div class="item">
          <p class="title">免费套餐</p>
          <ul>
            <li>申请人数过多时，需要排队审核 </li>
            <li>审核额度有限，建议选择VIP套餐 <span :class="isActive==0?'icon_act':'icon'"
                    @click="checkStatus(0)"></span></li>
          </ul>
        </div> -->
        <div v-for="(itm, idx) in memberInfoList"
             :key="idx">
            <div class="item"
                 :class="{ recommend_bg: itm.isRecommend == 1 }"
                 v-if="itm.memberTypeId !== 0">
                <p class="title">
                    {{ itm.vipOption }}
                    <span v-if="itm.isRecommend == 1"
                          class="recommend">推荐</span>
                    <span class="money"
                          v-if="itm.memberTypeId !== 0">{{ itm.price }} <span class="yu">元</span></span>
                </p>
                <ul>
                    <li v-for="(item, index) in itm.content.split(';')"
                        :key="index"
                        @click="checkStatus(idx, itm.price, itm.memberTypeId)">
                        <span class="circle"></span>
                        <span class="v_title" v-html="item.split('，')[0]"></span>
                        <span class="v_content">{{ item.split('，')[1] }}</span>
                        <span v-if="index == itm.content.split(';').length - 1"
                              class="icon1"
                              :class="{ icon1_act: isActive == idx }"></span>
                    </li>
                </ul>
            </div>
        </div>

        <div class="btn_box">
            <div class="btn"
                 @click="toSubmit('h5_vip_setmeal_submit_click')">
                确认提交
            </div>
            <div class="know"
                 v-if="scenceCode == 3 && showBtn"
                 @click="toPage">
                暂不加速
            </div>
        </div>
        <p v-if="showTips"
           class="show_pass"
           @click="updateProductAuth(1)">
            跳过，不加速了
        </p>
        <PayToast :isShow="isShow"
                  :isColor="isColor"
                  :payMoney="payMoney"
                  :scenceCode="scenceCode"
                  :memberTypeId="memberTypeId"
                  :noJson="noJson"
                  :productId="productId"
                  :orderId="orderId"
                  :buyEntrance="buyEntrance"
                  :eventKey="eventKey"></PayToast>
        <van-overlay :show="showTask"
                     @click="showTask = false">
            <div class="wrapper">
                <div class="task">
                    <img @click.stop="toSubmit('h5_vip_setmeal_submit_click')"
                         class="task_img"
                         src="@/assets/img/vip/change_vip.png"
                         alt=""/>
                    <img @click.stop="toHide"
                         class="task_close_img"
                         src="@/assets/img/vip/icon_close.png"
                         alt=""/>
                </div>
            </div>
        </van-overlay>

        <van-popup v-model:show="codeToast" :round="true" :closeable="true" :close-on-click-overlay="false"
                   @close="close()">
            <div class="codeToast">
                <div class="title">
                    <div class="img">
                        <img src="../../assets/img/vip/vip_yinlian.png">
                    </div>
                    <span>快捷支付</span>
                </div>
                <div class="center">
                    <div class="subTitle">请输入快捷支付验证码</div>
                    <div class="desc">已发送验证码到{{bankName}}的预留手机号</div>
                </div>
                <div class="inputs">
                    <!--<div v-for="(item,index) in inputList">
                        <input type="text" v-model="item.val" class="border-input" @keyup="nextFocus($event,index)"
                               @keydown="changeValue(index)">
                    </div>-->
                    <input type="text"
                           placeholder="请输入验证码"
                           class="inputStyle"
                           v-model="payCode" oninput="value=value.replace(/[^0-9.]/g,'')" maxlength="6"
                           style="width:100%;margin:0rem 0.2rem;padding-bottom:5px;border-bottom: 1px solid #979797;">
                </div>
                <div style="margin-top: 0.4rem;text-align: center;"><span class="resetSend"
                                                                          :class="{activeClass:activeClass}"
                                                                          @click="reachievemsg">{{codeMsg}}</span></div>
            </div>
            <Loading :isShow="loading2"></Loading>
            <Loading :isShow="loading3"></Loading>
        </van-popup>

        <Loading :isShow="loading1"></Loading>

    </div>
</template>

<script>
    import PayToast from "@/components/payToast";
    import Loading from '@/components/loading';

    export default {
        components: {
            PayToast, Loading
        },
        data() {
            return {
                eventKey: "h5_vip_setmeal_pay_click",
                payMoney: "19.9",
                noJson: true,
                isColor: false,
                userInfo: {},
                map: {},
                customerId: "",
                isActive: "",
                isShow: false,
                buyEntrance: 1,
                productAuthId: "",
                productId: 0,
                scenceCode: "", //场景
                info: "",
                content: "",
                memberInfoList: [],
                memberTypeId: "", //类型
                orderId: "",
                showBtn: false,
                showTips: false,
                showTask: false,
                toastFirst: true,
                codeToast: false, //银行卡支付的填写短信弹框
                inputList: [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}], //银行卡支付的最后密码集合
                payCode: "",
                timer: null,
                countdown: 40,
                codeMsg: "重新发送",
                paysn: "",
                activeClass: false,
                loading1: false,
                loading2: false,
                loading3: false,
                bankName: "",
            };
        },
        mounted() {
            this.scenceCode = this.$route.query.scenceCode;
            this.productId = this.$route.query.productId;
            this.orderId = this.$route.query.orderId;
            let str =
                "专属审批通道，审批速度提升40%, 审批通过率提升30%, 权益有效期：1个月";
            this.content = str.split(",");
            if (this.scenceCode == 2) {
                this.util.title("VIP加速审核");
            } else if (this.scenceCode == 3) {
                this.util.title("确认提交");
                this.info = "选择审批通道，请提交";
            } else if (this.scenceCode == 1) {
                this.util.title("加入VIP");
                this.info = "加入vip会员，享贷款特权";
            } else if (this.scenceCode == 4) {
                this.util.title("VIP加速审核");
                this.info = "选择审批通道并提交";
            } else if (this.scenceCode == 6) {
                this.util.title("VIP加速审核");
                this.info = "选择审批通道并提交";
            }
            if (window.history && window.history.pushState) {
                history.pushState(null, null, document.URL);
                window.addEventListener("popstate", this.goBack, false);
            }
            this.getMemberInfo();
        },
        destroyed() {
            window.removeEventListener("popstate", this.goBack, false);
        },
        watch: {  //监听银行卡支付的短信的输入
            payCode(newValue, oldValue) {
                if (newValue.length == 6) {
                    this.bankPayConfirm();
                }
            }
        },
        methods: {
            goBack() {
                if (this.toastFirst) {
                    this.showTask = true;
                    this.toastFirst = false;
                } else {
                    this.showTask = false;
                }
            },
            toHide() {
                this.showTask = false;
                //this.util.toClientPath(0);
                this.$router.push({
                    path: "/newpage/recommendPage",
                    query: {
                        showToast: false,
                    }
                });
            },
            //统计埋点
            toCountPoint(eventKey) {
                let param = {
                    event_key: eventKey,
                    vip_type: this.memberTypeId,
                    scene_code: this.scenceCode,
                };
                this.$get("/app/api/v1/newEventTrace", param)
                    .then((res) => {
                        if (res.code == 200) {
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {
                    });
            },
            getMemberInfo() {
                let _this = this;
                let param = {
                    scenceCode: this.scenceCode,
                };
                this.$get("/app/v1.0/memeber/memberTypeInfo", param)
                    .then((res) => {
                        if (res.code == 200) {
                            if (_this.scenceCode == "3") {
                                //区别成单后状态
                                res.data.filter(function (itm, idx) {
                                    if (itm.memberTypeId == "0" && itm.isEnable == 1) {
                                        //启用免费版——展示：暂不加速按钮
                                        _this.showBtn = true;
                                    } else {
                                        _this.memberInfoList.push(itm);
                                    }
                                });
                            } else {
                                _this.memberInfoList = res.data;
                            }
                            _this.memberInfoList.forEach((item, index) => {
                                var str = item.content.replace(/提速30%/g, "<span style=\"color:#ee6c67\">提速30%</span>");
                                str = str.replace(/提速50%/g, "<span style=\"color:#ee6c67\">提速50%</span>");
                                str = str.replace(/免费/g, "<span style=\"color:#ee6c67\">免费</span>");
                                str = str.replace(/30元/g, "<span style=\"color:#ee6c67\">30元</span>");
                                str = str.replace(/40元/g, "<span style=\"color:#ee6c67\">40元</span>");
                                _this.memberInfoList[index].content = str;
                            });
                            _this.memberInfoList.map(function (itm, idx) {
                                if (itm.isDefault == 1) {
                                    _this.isActive = idx;
                                    _this.payMoney = itm.price;
                                    _this.memberTypeId = itm.memberTypeId;
                                }
                                // else {
                                //   _this.isActive = 0
                                //   _this.payMoney = _this.memberInfoList[0].price;
                                //   _this.memberTypeId = _this.memberInfoList[0].memberTypeId
                                // }
                            });
                            _this.memberInfoList.map((item) => {
                                if (item.memberTypeId == 0) {
                                    this.showTips = true;
                                }
                            });
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {
                    });
            },
            updateProductAuth(status) {
                let param = {
                    productId: this.productId,
                    memberOrderSource: this.scenceCode,
                };
                this.$post("/app/v1.0/memeber/buyFreeMember", param)
                    .then((res) => {
                        if (res.code == 200 && status) {
                            if (this.scenceCode == 4) {
                                this.$router.push({
                                    path: "/newpage/recommendPage",
                                    query: {
                                        showToast: false,
                                    }
                                });
                                /*this.$get("/app/v1.0/pay/getReturnUrl", {scenceCode:this.scenceCode})
                                        .then((res) => {
                                          if (res.code == 200 && status) {
                                            window.location.href = res.data
                                          } else {
                                            this.authSuccess();
                                          }
                                        })
                                        .catch((error) => { });*/
                            } else {   //sceneCode为2的时候,还是走以前的逻辑
                                this.authSuccess();
                            }
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {
                    });
            },
            //切换状态
            checkStatus(isDefault, price, memberTypeId) {
                this.isActive = isDefault;
                this.payMoney = price;
                this.memberTypeId = memberTypeId;
            },
            toShow() {
                this.isShow = true;
            }, toSubmit(eventKey) {
                this.showTask = false;
                this.toCountPoint(eventKey); //去埋点
                if (this.memberTypeId == 0) {
                    //是免费版
                    this.updateProductAuth(1);
                    this.isShow = false;
                } else {
                    if (this.scenceCode != 6) {
                        this.isShow = true;
                    } else {
                        this.bankPay();
                        /*this.codeToast = true;
                        this.setTime();
                        this.activeClass = true;*/
                    }
                }
            },
            toPage() {
                /*this.updateProductAuth();
                this.isShowBtn();*/
                //去申请成功页面
                this.$router.push({
                    path: "/newpage/recommendPage",
                    query: {
                        showToast: false,
                    },
                    // path: "/afterLoan/applySuccess",
                    // query: {
                    //   status: "1",
                    //   orderId: this.orderId,
                    // },
                });
            },
            isShowBtn() {
                //调用ios的方法——展示左侧按钮
                try {
                    window.webkit.messageHandlers.isShowBtn.postMessage(""); //ios
                } catch (err) {
                    window.AppJs.isShowBtn(); //android
                }
            }, authSuccess() { //调用android和ios的方法
                try {
                    window.webkit.messageHandlers.authSuccess.postMessage(""); //ios
                } catch (err) {
                    window.AppJs.authSuccess(); //android
                }
            }, nextFocus(el, index) { /*对焦到下一个input框去*/
                var dom = document.getElementsByClassName("border-input"),
                    currInput = dom[index],
                    nextInput = dom[index + 1],
                    lastInput = dom[index - 1];
                /*这里的keyCode 根据不同的平台或许不同,安卓就是不是8*/
                if (el.keyCode != 8) {
                    if (index < (this.inputList.length - 1)) {
                        nextInput.focus();
                    } else {
                        currInput.blur();
                    }

                } else {
                    if (index != 0) {
                        lastInput.focus();
                    }
                }

            }, changeValue(index) { /*当键盘按下的时候清空原有的数*/
                this.inputList[index].val = "";
            }, setTime() {//倒计时1
                let _this = this;
                this.timer = setInterval(() => {
                    if (_this.countdown > 0 && _this.countdown <= 40) {
                        _this.countdown--;
                        if (_this.countdown !== 0) {
                            _this.codeMsg = _this.countdown + "s后可重新发送";
                        } else {
                            clearInterval(_this.timer);
                            _this.codeMsg = "重新发送";
                            _this.countdown = 40;
                            _this.timer = null;
                            _this.activeClass = false;
                        }
                    }
                }, 1000)
            }, reachievemsg() {
                if (this.codeMsg.includes("s后")) {
                    return;
                }
                if (!this.paysn) {
                    this.util.toast({msg: "交易流水号不能为空"});
                    return;
                }
                let param = {
                    paysn: this.paysn,
                };
                this.loading3 = true;
                this.$post("/app/v1.0/payBank/ysFastPay/reachievemsg", param)
                    .then((res) => {
                        if (res.code == 200) {
                            this.loading3 = false;
                            this.setTime();
                            this.activeClass = true;
                            this.util.toast({msg: "短信发送成功"});
                        } else {
                            this.loading3 = false;
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {
                        this.loading3 = false;
                    });
            }, bankPay() {
                let payParam = {
                    prepaid: this.prepaid,
                    memberTypeId: this.memberTypeId,
                    productId: this.productId
                }
                this.loading1 = true;
                this.$post('/app/v1.0/payBank/ysFastPay', payParam)
                    .then(res => {
                        var e = res;
                        if (e.code == 400) {
                            this.loading1 = false;
                            this.util.toast({msg: e.message})
                            this.$router.push({
                                path: "/newpage/recommendPage",
                                query: {
                                    showToast: false,
                                }
                            });
                        } else if (e.code == 200) {
                            this.loading1 = false;
                            this.codeToast = e.data.needSmsConfirm;
                            if (!this.codeToast) {
                                this.$router.push({
                                    path: "/afterLoan/newApplySuccess",
                                    query: {
                                        status: 1
                                    },
                                });
                            }
                            this.paysn = e.data.paysn;
                            this.bankName = e.data.bankName;
                            this.codeToast = true;
                            this.setTime();
                            this.activeClass = true;
                        } else {
                            this.loading1 = false;
                            this.util.toast({msg: e.message})
                        }
                    })
                    .catch(error => {
                        this.loading1 = false;
                    });
            }, bankPayConfirm() {
                if (!this.payCode) {
                    this.util.toast({msg: "验证码不能为空"});
                    return;
                }
                let param = {
                    paysn: this.paysn,
                    mobileVerifyCode: this.payCode
                }
                this.loading2 = true;
                this.$post('/app/v1.0/payBank/ysFastPay/confirm', param)
                    .then(res => {
                        var e = res;
                        if (e.code == 200) {
                            this.loading2 = false;
                            this.$get("/app/v1.0/pay/getReturnUrl?scenceCode=" + this.scenceCode)
                                .then((res) => {
                                    if (res.code == 200) {
                                        window.location.href = res.data;
                                    } else {
                                        this.util.toast({msg: res.message});
                                    }
                                })
                                .catch((error) => {
                                    this.loading2 = false;
                                });
                            this.codeToast = false;
                        } else {
                            this.loading2 = false;
                            this.util.toast({msg: e.message})
                        }
                    })
                    .catch(error => {
                        this.loading2 = false;
                    });
            }, close() {
                this.inputList.forEach(e => {
                    e.val = "";
                })
            },


        },
    };
</script>
<style scoped>
    .dp {
        display: block;
    }

    .check_box {
        background: #f7f7f7;
        padding-top: 0.15rem;
        font-family: PingFangSC-Medium;
    }

    .item {
        background: #fff;
        margin: 0.15rem;
        margin-top: 0;
        position: relative;
        border-radius: 8px;
        padding: 0.21rem 0.15rem 0.2rem 0.13rem;
        font-size: 0.17rem;
        margin-bottom: 0.1rem;
    }

    .i_title {
        font-size: 0.16rem;
        color: #333;
        padding: 0.12rem;
    }

    .line {
        display: inline-block;
        margin-right: 0.1rem;
        width: 0.03rem;
        height: 0.12rem;
        background: #5ec79c;
    }

    .item .title {
        color: #333;
        font-weight: bold;
        margin-bottom: 0.12rem;
    }

    .item .money {
        color: #ee6c67;
        float: right;
        font-size: 0.24rem;
        position: relative;
        top: -0.06rem;
    }

    .item .yu {
        font-size: 0.14rem;
    }

    .item li {
        color: #999;
        font-size: 0.14rem;
        font-weight: 400;
        margin-top: 0.05rem;
    }

    .item li:last-child {
        margin-bottom: 0;
    }

    .item ul {
        position: relative;
    }

    .item .circle {
        display: inline-block;
        width: 0.03rem;
        height: 0.03rem;
        background: #333;
        position: relative;
        top: -4px;
        border-radius: 50%;
        margin-right: 0.03rem;
    }

    .btn {
        background: linear-gradient(
                90deg,
                rgba(122, 157, 246, 1) 0%,
                rgba(81, 117, 241, 1) 100%
        );
        box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
        border-radius: 25px;
        margin: 0.15rem;
        text-align: center;
        color: #fff;
        height: 0.5rem;
        font-size: 0.17rem;
        line-height: 0.5rem;
        margin-top: 0;
        margin-bottom: 0.2rem;
        /* margin-top: 0.4rem; */
    }

    .icon,
    .icon1,
    .icon_act,
    .icon1_act {
        background: url('../../assets/img/vip/choice_unCheck.png') no-repeat top center;
        background-size: 100% 100%;
        width: 0.24rem;
        height: 0.24rem;
        display: inline-block;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(0, -50%);
    }

    .icon_act,
    .icon1_act {
        background: url('../../assets/img/vip/choice_check.png') no-repeat top center;
        background-size: 100% 100%;
    }

    .recommend {
        font-size: 0.12rem;
        border: 1px solid #ffe6d4;
        background: #ffe6d4;
        color: #ff6a48;
        padding: 0 0.03rem;
        margin-left: 3px;
        position: relative;
        top: -1px;
    }

    .info {
        padding: 0 0.15rem 0.15rem 0.05rem;
        color: #999;
        font-size: 0.15rem;
    }

    .know {
        color: #999;
        font-size: 0.15rem;
        text-align: center;
        padding: 0.1rem;
        width: 30%;
        margin: 0 auto;
    }

    .btn_box {
        /* position: fixed; */
        width: 100%;
        /* bottom: 0.3rem; */
        /* left: 0; */
        padding: 0.2rem 0;
    }

    .line {
        display: inline-block;
        width: 0.03rem;
        height: 0.13rem;
        background: linear-gradient(
                90deg,
                rgba(122, 157, 246, 1) 0%,
                rgba(81, 117, 241, 1) 100%
        );
        box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
        border-radius: 25px;
    }

    .recommend_bg {
        background: rgba(255, 249, 246, 1);
        border: 1px solid #ffa849;
    }

    .show_pass {
        color: rgba(153, 153, 153, 1);
        font-size: 0.15rem;
        text-align: center;
        padding-bottom: 0.2rem;
    }

    /* 弹框 */
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .task_img {
        width: 2.55rem;
        height: auto;
    }

    .task_close_img {
        width: 0.3rem;
        height: auto;
        margin-top: 0.4rem;
    }

    .task {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    >>> .van-overlay {
        background-color: rgba(0, 0, 0, 0.4);
    }

    .v_title {
        font-size: 0.14rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0E0D0D;
    }

    .v_content {
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin-left: 0.05rem;
    }

    .codeToast {
        width: 2.95rem;
        background: #FFFFFF;
        padding-bottom: 0.3rem;
    }

    .codeToast .title {
        font-size: 0.2rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #424242;
        letter-spacing: 1px;
        margin-top: 0.3rem;
        display: flex;
        justify-content: center;
    }

    .codeToast .title .img {
        width: 0.35rem;
        height: 0.25rem;
        margin-right: 3px;
    }

    .codeToast .title .img img {
        width: 100%;
        height: 100%;
    }

    .codeToast span {
        font-size: 0.2rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
    }

    .codeToast .center {
        margin-left: 0.2rem;
        margin-top: 0.1rem;
    }

    .codeToast .subTitle {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
    }

    .codeToast .desc {
        font-size: 0.1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .codeToast .btn {
        width: 2.59rem;
        height: 0.5rem;
        background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
        border-radius: 0.25rem;
        line-height: 0.5rem;
        text-align: center;
        margin: 0.2rem auto;
    }

    .codeToast .btn span {
        font-size: 0.18rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 0.17rem;
    }

    .codeToast .resetSend {
        font-size: 0.13rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3B72FF;
    }

    .border-input {
        background: #ffffff;
        width: 0.31rem;
        font-size: 0.18rem;
        height: 0.31rem;
        margin-left: 0.1rem;
        margin-right: 0.05rem;
        text-align: center;
        border-bottom: 1px solid #333333;
        border-top: 0px;
        border-left: 0px;
        border-right: 0px;
    }

    .inputs {
        margin-top: 0.15rem;
        display: flex;
        justify-content: center;
    }

    .activeClass {
        font-size: 0.13rem !important;;
        font-weight: 400 !important;
        color: #999999 !important;
    }

</style>
